// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1QWft","content":"GlobalSearch_content__2j9hU"};